import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import logger from "@shared/utils/logger.ts";
import { maintenanceStatus } from "@shared/services/maintenanceStatus.ts";
import { analyticsService } from "@shared/services/analytics.ts";
import partnerPortal from "@/partner-router/route/partnerPortal.ts";
import login from "@/partner-router/route/login.ts";
import { RouteNames } from "@shared/types/localTypes/router.ts";
import { useGlobalLoaderStore } from "@shared/stores/globalLoader.ts";
import { useKeycloakStore } from "@shared/stores/keycloak.ts";
import errors from "@/router/route/errors.ts";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: RouteNames.Root,
    redirect: { name: RouteNames.Partnerships },
    children: [],
  },
  ...login,
  errors,
  ...partnerPortal,
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  linkActiveClass: "partner-active-link",
});

router.onError((error) => {
  const message = error?.message;

  if (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Importing a module script failed")
  ) {
    logger.error(`Force Browser Reload on: ${message}`);
    window.location.reload();
  }
});

let lastRouteName: string = "undefined";

router.beforeEach(async (to) => {
  maintenanceStatus.checkIsMyJfUnderMaintenance();

  await useKeycloakStore().initializeKeycloak();
  useGlobalLoaderStore().hide();

  lastRouteName = router.currentRoute.value.name?.toString() || "unknown";

  if (to.meta.requiresAuth && !useKeycloakStore().keycloak?.authenticated) {
    return { name: RouteNames.Login };
  }
});

router.afterEach(async (to) => {
  document.title = "Partner Portal - " + (to.name as string);

  analyticsService.track("page_view", {
    page_name: router.currentRoute.value.name?.toString() || "unknown",
    prev_page: lastRouteName,
  });
});

export default router;
